module.exports = __webpack_public_path__ + "media/images/admin2/DatePicker__handle__close-9e9b1a51758767ab6f959358a5a0b8d8.svg";